import styled from "styled-components";
import { TextButton as Button, BREAKPOINTS, COLORS, DropdownFilter, TooltipWrapper } from "@laerdal/life-react-components";

export const LinkContainer = styled.div`
    margin-left: 46px;
`;

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap:32px;
    display: flex;
    align-items: start;
    margin: 32px 0;    
`;

export const CaseContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 21px;
    
    align-self: center;
    align-items: start;

    
    width: 100%;
`;

export { CaseTitle as Title, CaseSubTitle as SubTitle, CaseHeader as Header } from "./components/CommonCaseComponents";

export const Breadcrumb = styled.div`
  padding:12px 0;
`;

export const CrumbLink = styled.a`
  &:link, &:visited, &:hover, &:active {
    color: ${COLORS.primary_600};
    text-decoration: none; 
  }

  color: ${COLORS.primary_600};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const CrumbText = styled.span`
  color: ${COLORS.neutral_500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const Devider = styled.span`
  padding: 0 10px;
  color: ${COLORS.neutral_500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const InputRow = styled.div`
    ${BREAKPOINTS.MEDIUM}{
        flex-direction: row;
    }
    flex-direction: column;

    display: flex;
    align-items: flex-start;
    gap: 32px;
    align-self: stretch;

    &:not(:has(> :not(input[type="hidden"]))) {
        display: none;
    }
`;

export const RadioRow = styled.div`
    flex-direction: row;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    align-self: start;
    
`;

export const InputCell = styled.div`
    width: 100%;
    min-width: 0;
    align-self: stretch;
    display: flex;
    padding-bottom: 4px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex-grow: 1;

    div {
        width: 100%;
        min-width: 0;
    }

    textarea {
        width: calc(100% - 32px) !important;
        min-height:100px;
    }
`;

export const InputCell2 = styled.div`
    width: 100%;
    align-self: stretch;
    display: flex;
    padding-bottom: 4px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex-grow: 1;
    textarea {
        width: calc(100% - 32px) !important;
        min-height:100px;
    }
`;

export const CreateButton = styled(Button)`
    ${BREAKPOINTS.MEDIUM}{
        align-self: end;
    }
    align-self: stretch;
`;

export const ChoseFileContainerText = styled.div`
    ${BREAKPOINTS.MEDIUM}{
        display: flex;
    }
    display: none;
`;

export const ChoseFileContainer = styled.div`
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    

    height: 152px;
    gap:21px;

    
    border-radius: 4px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none'  rx='4' ry='4' stroke='%23949494' stroke-width='2' stroke-dasharray='16%2c 16' stroke-dashoffset='12' stroke-linecap='square'/%3e%3c/svg%3e");
`;

export const AttachmentsContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: start;
  gap: 16px;
  background-color: ${COLORS.neutral_20};
  padding: 24px 30px;
`;

export const AttachmentDetails = styled.div`
  ${BREAKPOINTS.MEDIUM}{
    padding: 0px 10px;
  }
  padding: 5px 10px;

  background-color: ${COLORS.white};
  display:flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  min-width: 0;

  > *:last-child {
    overflow-wrap: break-word;
    word-break: break-word;
    min-width: 0;
  }
`;

export const AttachmentHeader = styled.div`
  display:flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const Tooltip = styled(TooltipWrapper)`
    ${BREAKPOINTS.MEDIUM}{
        width: max-content;
    }
    width: unset;
`;

export const FullWidth = styled.div`
  border-top: 1px solid ${COLORS.neutral_200};
  background: ${COLORS.neutral_20};
`;

export const CaseForm = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 21px;
`;



export const CaseDropdownFilter = styled(DropdownFilter)`
    min-width: 0 !important;
    
    > div {
        min-width: 0 !important;
    }

`;

export const DropdownContainer = styled.div`
  & > div > div:first-child > div:nth-child(2) {
        width: 20px;
    }
`;
